module.exports = __webpack_public_path__ + "static/media/delivery.f482e714.png";